import styled from 'styled-components';

export const Container = styled.section``;

export const TabContainer = styled.div`
  margin-bottom: 24px;
`;
